import { Building2, Cpu, Factory, Stethoscope, ShoppingBag, ShoppingCart, Boxes, GraduationCap, Building, Rocket } from "lucide-react";

const industries = [
  { icon: Building2, name: "BFSI", desc: "Banking, Insurance & Financial Services" },
  { icon: Cpu, name: "IT & Technology", desc: "Software, Cloud, AI, DevOps" },
  { icon: Factory, name: "Manufacturing & Engineering", desc: "Automotive, Industrial, Production" },
  { icon: Stethoscope, name: "Healthcare & Pharma", desc: "Hospitals, Diagnostics, Lifesciences" },
  { icon: ShoppingBag, name: "FMCG / FMCD", desc: "Consumer Goods & Durables" },
  { icon: ShoppingCart, name: "E-Commerce & Retail", desc: "D2C, Marketplaces, Retail Chains" },
  { icon: Boxes, name: "SAP & Enterprise Apps", desc: "SAP, Oracle, Salesforce" },
  { icon: GraduationCap, name: "Education & EdTech", desc: "K-12, Higher Ed, Online Learning" },
  { icon: Building, name: "Real Estate & Infra", desc: "Construction, Developers" },
  { icon: Rocket, name: "Startups & SMEs", desc: "Funded startups, founding teams" },
];

export default function Industries() {
  return (
    <section id="industries" className="py-20 lg:py-24" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] text-bee-orange font-semibold mb-3">Industries We Serve</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
            Deep expertise across <span className="text-bee-teal">15+ sectors</span>.
          </h2>
        </div>
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {industries.map((ind, i) => (
            <div
              key={ind.name}
              data-testid={`industry-${i}`}
              className="group rounded-2xl border border-border bg-card p-5 card-lift"
            >
              <span className="h-11 w-11 rounded-xl bg-secondary text-bee-teal group-hover:bg-bee-teal group-hover:text-white inline-flex items-center justify-center transition-colors">
                <ind.icon className="h-5 w-5" />
              </span>
              <div className="mt-4 font-display font-bold text-sm leading-tight">{ind.name}</div>
              <div className="text-xs text-muted-foreground mt-1">{ind.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
